/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Markers_LabelInputs */



/**
* | output |
* | --- |
* | "Publish marker metadata" |
*
* @param {Iconik_Publish_Markers_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_label = /** @type {((inputs?: Iconik_Publish_Markers_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "de") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "it") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Publish marker metadata")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publish marker metadata")
	return /** @type {LocalizedString} */ ("Publish marker metadata")
});